
import makeInstaller from './make-install'
import Components    from './component'

export default makeInstaller([...Components])
